import { Pipe, PipeTransform } from '@angular/core';

import { hourClass } from '../constants/constants';

@Pipe({ name: 'hourClass' })
export class HourClassPipe implements PipeTransform {
  transform(
    hour: number,
    selectedTimeStep: number,
    stations: any[],
    stationTime: any
  ) {
    return hourClass(hour, selectedTimeStep, stations, stationTime);
  }
}
